export default __webpack_public_path__ + "static/checknlearn-promo-small@1x-eb9b96326c035c6f229384b006f21795.webp";